<template>
  <div class="app-header">
    <div class="app-header__inner">
      <div class="app-header__branding">
        <router-link to="/" class="app-header__branding__link">
          <img class="app-header__branding__icon" src="../../assets/icon-eti-no-text.svg" alt="">
          <div class="app-header__branding__text">ETI Annual Impact Report</div>
        </router-link>
      </div>
      <div class="app-header__year">
        <span class="year">{{ yearMostRecent }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AppHeader',
    computed: {
      yearMostRecent() {
        return this.$store.state.globalData.defaults.data.defaultLabels.labels.slice(-1)[0]
      }
    }
  }
</script>

<style src="./AppHeader.scss" lang="scss"></style>
